'use client';

import { useState } from 'react';
import { useRouter } from 'next/navigation';
import { toastError } from '@/utils/toastUtils';
interface DismissPoppyBadgeButtonProps {
  landingPageId: string;
  onDismissed: () => void;
}
export function DismissPoppyBadgeButton({
  landingPageId,
  onDismissed
}: DismissPoppyBadgeButtonProps) {
  const [isLoading, setIsLoading] = useState(false);
  const router = useRouter();
  const handleDismiss = async () => {
    setIsLoading(true);
    try {
      const response = await fetch('/api/landing-page/update', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          landingPageId,
          updates: {
            hidePoppyBadge: true
          }
        })
      });
      if (response.ok) {
        onDismissed();
        router.refresh();
      } else {
        const errorData = await response.json().catch(() => ({
          error: 'Unknown error'
        }));
        toastError(errorData.error || 'Failed to hide badge');
      }
    } catch (error) {
      console.error('Error dismissing badge:', error);
      toastError('Failed to hide badge');
    } finally {
      setIsLoading(false);
    }
  };
  return <button aria-label='Hide badge' className='absolute -right-1.5 -top-1.5 flex h-4 w-4 items-center justify-center rounded-full bg-white/90 text-gray-500 shadow-sm transition-colors hover:bg-white hover:text-gray-800 disabled:cursor-not-allowed' disabled={isLoading} onClick={handleDismiss} type='button'>
      {isLoading ? <svg aria-hidden='true' className='h-2.5 w-2.5 animate-spin' fill='none' viewBox='0 0 24 24'>
          <circle className='opacity-25' cx='12' cy='12' r='10' stroke='currentColor' strokeWidth='3' />
          <path className='opacity-75' d='M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4z' fill='currentColor' />
        </svg> : <svg aria-hidden='true' className='h-2.5 w-2.5' fill='none' stroke='currentColor' strokeWidth={2.5} viewBox='0 0 24 24'>
          <path d='M6 18L18 6M6 6l12 12' strokeLinecap='round' strokeLinejoin='round' />
        </svg>}
    </button>;
}